import axiosInstance from '@/core/api'
import {
	GetChannelAnalyticsRequest,
	GetChannelAnalyticsResponse,
	GetOverallAnalyticsRequest,
	GetOverallAnalyticsResponse,
	GetOverallAnalyticsCumulativeResponse,
	GetOverallAnalyticsAggregateResponse,
	GetWithDrawDepositGraphRequest,
	GetWithDrawDepositGraphResponse,
	GetPlayerDepositWithdrawGraphRequest,
	GetPlayerDepositWithdrawGraphResponse,
	GetTransactionSummaryRequest,
	GetTransactionSummaryResponse,
	GetChannelTransactionCumulativeRequest,
	GetChannelTransactionCumulativeResponse,
	GetPromotionAnalyticsRequest,
	GetPromotionAnalyticsResponse,
	GetPromotionDetailRequest,
	GetPromotionDetailResponse,
	GetOnlineActiveUserResponse,
	GetLineAnalyticsRequest,
	GetLineAnalyticsResponse,
	GetActiveUsersRequest,
	GetActiveUsersResponse,
	GetActiveUsersSummaryRequest,
	GetActiveUsersSummaryResponse,
	GetChannelPlayersRequest,
	GetChannelPlayersResponse,
	GetChannelCohortAnalyticsResponse,
} from '../../type'

export const getChannelAnalytics = async (
	payload: GetChannelAnalyticsRequest,
): Promise<GetChannelAnalyticsResponse> => {
	const response = await axiosInstance.get<GetChannelAnalyticsResponse>(
		'/admin/analytics/channels',
		{
			params: payload,
		},
	)
	return response.data
}

export const getOverallAnalytics = async (
	payload: GetOverallAnalyticsRequest,
): Promise<GetOverallAnalyticsResponse> => {
	const response = await axiosInstance.get<GetOverallAnalyticsResponse>(
		'/admin/analytics/overall',
		{
			params: payload,
		},
	)
	return response.data
}

export const getOverallAnalyticsCumulative = async (
	payload: GetOverallAnalyticsRequest,
): Promise<GetOverallAnalyticsCumulativeResponse> => {
	const response =
		await axiosInstance.get<GetOverallAnalyticsCumulativeResponse>(
			'/admin/analytics/overall/cumulative',
			{
				params: payload,
			},
		)
	return response.data
}

export const getOverallAnalyticsAggregate = async (
	payload: GetOverallAnalyticsRequest,
): Promise<GetOverallAnalyticsAggregateResponse> => {
	const response =
		await axiosInstance.get<GetOverallAnalyticsAggregateResponse>(
			'/admin/analytics/overall/aggregate',
			{
				params: payload,
			},
		)
	return response.data
}

export const getWithDrawDepositGraph = async (
	payload: GetWithDrawDepositGraphRequest,
): Promise<GetWithDrawDepositGraphResponse> => {
	const response = await axiosInstance.get<GetWithDrawDepositGraphResponse>(
		'/admin/analytics/deposit-withdraw-graph',
		{
			params: payload,
		},
	)
	return response.data
}

export const getPlayerDepositWithdrawGraph = async (
	payload: GetPlayerDepositWithdrawGraphRequest,
): Promise<GetPlayerDepositWithdrawGraphResponse> => {
	const response =
		await axiosInstance.get<GetPlayerDepositWithdrawGraphResponse>(
			`/admin/analytics/player-deposit-withdraw-graph`,
			{
				params: payload,
			},
		)
	return response.data
}

export const getTransactionSummary = async (
	payload: GetTransactionSummaryRequest,
): Promise<GetTransactionSummaryResponse> => {
	const response = await axiosInstance.get<GetTransactionSummaryResponse>(
		'/admin/analytics/transaction-summary',
		{
			params: payload,
		},
	)
	return response.data
}

export const getChannelTransactionCumulative = async (
	channelId: string,
	payload: GetChannelTransactionCumulativeRequest,
): Promise<GetChannelTransactionCumulativeResponse> => {
	const response =
		await axiosInstance.get<GetChannelTransactionCumulativeResponse>(
			`/admin/operators/channels/${channelId}/transaction-cumulative`,
			{
				params: payload,
			},
		)
	return response.data
}

export const getPromotionAnalytics = async (
	payload: GetPromotionAnalyticsRequest,
): Promise<GetPromotionAnalyticsResponse> => {
	const response = await axiosInstance.get<GetPromotionAnalyticsResponse>(
		'/admin/analytics/promotions',
		{
			params: payload,
		},
	)
	return response.data
}

export const getPromotionDetail = async (
	payload: GetPromotionDetailRequest,
): Promise<GetPromotionDetailResponse> => {
	const response = await axiosInstance.get<GetPromotionDetailResponse>(
		'/admin/analytics/promotions/detail',
		{
			params: payload,
		},
	)
	return response.data
}

export const getOnlineActiveUser =
	async (): Promise<GetOnlineActiveUserResponse> => {
		const response = await axiosInstance.get<GetOnlineActiveUserResponse>(
			'/admin/analytics/online-users',
		)
		return response.data
	}

export const getLineAnalytics = async (
	payload?: GetLineAnalyticsRequest,
): Promise<GetLineAnalyticsResponse> => {
	const response = await axiosInstance.get<GetLineAnalyticsResponse>(
		'/admin/analytics/line/analytics',
		{
			params: payload,
		},
	)
	return response.data
}

export const getActiveUsers = async (
	payload?: GetActiveUsersRequest,
): Promise<GetActiveUsersResponse> => {
	const response = await axiosInstance.get<GetActiveUsersResponse>(
		'/admin/analytics/active-users',
		{
			params: payload,
		},
	)
	return response.data
}

export const getActiveUsersSummary = async (
	payload?: GetActiveUsersSummaryRequest,
): Promise<GetActiveUsersSummaryResponse> => {
	const response = await axiosInstance.get<GetActiveUsersSummaryResponse>(
		'/admin/analytics/active-users/summary',
		{
			params: payload,
		},
	)
	return response.data
}

export const getChannelPlayers = async (
	channelId: string,
	payload?: GetChannelPlayersRequest,
): Promise<GetChannelPlayersResponse> => {
	const response = await axiosInstance.get<GetChannelPlayersResponse>(
		`/admin/operators/channels/${channelId}/players`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getChannelCohortAnalytics = async (
	channelId: string,
): Promise<GetChannelCohortAnalyticsResponse> => {
	const response = await axiosInstance.get<GetChannelCohortAnalyticsResponse>(
		`/admin/operators/channels/${channelId}/cohort-analytics`,
	)
	return response.data
}
